<template>
<div :class="classObj" class="app-wrapper">
  <div class="head-wrap index-head-wrap bg-black" >
    <com-header loginType="apiDoc"></com-header>
  </div>
  <section class="section-wrapper">
    <sidebar class="sidebar-container" />
    <section class="main-container">
      <el-scrollbar class="app-main-scroll">
        <app-main />
      </el-scrollbar>
    </section>
  </section>
</div>
</template>

<script>
import { AppMain, Sidebar } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import { mapState } from 'vuex'
export default {
  name: 'Index',
  components: {
    AppMain,
    Sidebar,
    'com-header': resolve => require(['@/components/common/Header.vue'], resolve)
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapState({
      sidebar: state => state.app.sidebar,
      device: state => state.app.device
    }),
    classObj () {
      return {
        hideSidebar: !this.sidebar.opened,
        openSidebar: this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
  @import "~@/styles/variables.scss";
  .bg-black{background: #222222;}
  .app-wrapper {
    @include clearfix;
    @include relative;

    &.mobile.openSidebar {
      position: fixed;
      top: 0;
    }
    .section-wrapper{}
  }
  /deep/ .el-menu-item{
    height:97px;
    line-height: 97px;
    font-size: 24px;
    color:#333!important;
    border-bottom:2px dashed #dddddd;
    padding: 0 46px 0 38px;
    &.is-active{color:#4684ff!important;}
  }
  /deep/ .el-scrollbar__wrap {
     overflow-x: hidden;
   }
</style>



// WEBPACK FOOTER //
// src/layout/Index.vue